<div
  class="monitor-close-button"
  (click)="onClose.emit()">
</div>

<div #monitorLayoutContainer class="monitor_container">
  <app-monitor-dashboard
    [test]="test"
    [testLoading]="testLoading"
    [patient]="patient"
    [bundle]="bundle"
    [screen]="screen"
    [isTestDone]="isTestDone"
    [isTestSyncing]="isTestSyncing"
    [deviceLoading]="deviceLoading"
    [device]="device"
    [batteryPercentage]="batteryPercentage"
    [streamPopupVisible]="streamPopupVisible"
    [isSingleImage]="isSingleImage"
    [isV2Streaming]="isV2Streaming"
    [deviceActionLoading]="deviceActionLoading"
    (onStreamOpen)="onStreamOpen.emit($event)"
    (onStreamClose)="onStreamClose.emit($event)"
    (onActionClicked)="onActionClicked.emit($event)">
  </app-monitor-dashboard>

  @if (!isHeadsetAlignmentShown) {
    <ng-content></ng-content>
  }

  @if (isHeadsetAlignmentShown) {
    <div
      class="monitor_container-column monitor_container-column--single monitor_headset-alignment_container-column" (window:resize)="windowChanged.emit(getEvent())">
      <div class="monitor_headset-alignment_plots">
        <div class="monitor_graph-box monitor_headset-alignment_graph-box">
          <div class="monitor_graph-title">{{ 'right' | translate | titlecase }}</div>
          <plotly-plot [data]="headsetAlignmentOdData" [layout]="headsetAlignmentLayoutRight" [config]="monitorTestService.plotOptions"
            [revision]="headsetAlignmentRevision" [debug]="true" class="monitor_plot-box">
          </plotly-plot>
        </div>
        <div class="monitor_graph-box monitor_headset-alignment_graph-box headset_alignment_plot_container">
          <div class="monitor_graph-title">{{ 'left' | translate | titlecase }}</div>
          <plotly-plot [data]="headsetAlignmentOsData" [layout]="headsetAlignmentLayoutLeft" [config]="monitorTestService.plotOptions"
            [revision]="headsetAlignmentRevision" [debug]="true" class="monitor_plot-box">
          </plotly-plot>
        </div>
      </div>
      <div class="monitor_graph-box monitor_headset-alignment_control">
        <div class="monitor_headset-alignment_status">
          @if (!headsetAlignment) {
            <span
            class=" monitor_headset-alignment_status--no-data">{{'noTestDataReceived' | translate | uppercase}}</span>
          }
          @if (headsetAlignment && headsetAlignment.OD.aligned && headsetAlignment.OS.aligned) {
            <span
            class=" monitor_headset-alignment_status--aligned">{{'aligned' | translate | uppercase}}</span>
          }
          @if (headsetAlignment && !(headsetAlignment.OD.aligned && headsetAlignment.OS.aligned)) {
            <span
            class=" monitor_headset-alignment_status--not-aligned">{{'notAligned' | translate | uppercase}}</span>
          }
        </div>
        <div class="monitor_headset-alignment_control-buttons">
          <button class="button button--primary form_button"
            (click)="onHeadsetAlignmentConfirm()"
            [disabled]="!canConfirmHeadsetAlignment">
            <span class="regular">{{'confirm' | translate | titlecase}}</span>
          </button>
          <div>
            <input
              type="checkbox"
              class="checkbox_input"
              id="headset_alignment_override"
              name="headset_alignment_override"
              [(ngModel)]="headsetAlignmentOverride">
              <label
                for="headset_alignment_override"
                class="checkbox_label">
                {{'override' | translate | lowercase}}
              </label>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  @if (isLoading) {
    <app-loader [transparent]="true"></app-loader>
  }